import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { ValidationService } from '../../services/validation.service';
import { ChassisFormHandler } from '../../classes/form-handler';
import { TranslateService } from '@ngx-translate/core';
import { Collection } from '../../../../support/collection/collection';

@Component({
    selector: 'chassis-form-messages',
    templateUrl: 'messages.component.html',
    styleUrls: ['messages.component.scss']
})
export class MessagesComponent implements OnInit, OnDestroy {

    /**
     * The ChassisFormHandler instance.
     */
    @Input() form: ChassisFormHandler;

    /**
     * The form element.
     */
    @Input() element: any;

    /**
     * The element's Control instance.
     */
    protected control: any;

    /**
     * The ValidationService instance.
     */
    protected validationService: ValidationService;

    /**
     * The TranslateService instance.
     */
    protected translateService: TranslateService;

    /**
     * Constructor.
     *
     * @param injector
     */
    constructor(protected injector: Injector) {
        this.validationService = this.injector.get(ValidationService);
        this.translateService  = this.injector.get(TranslateService);
    }

    /**
     * OnInit.
     */
    ngOnInit() {
    }

    /**
     * Get form validation errors.
     *
     * @returns {Collection}
     */
    get errors(): Collection {
        const errors = new Collection;

        if (this.form) {
            this.control = this.form.formGroup.controls[this.element.name];

            // Get all frontend validation errors.
            if (this.control) {
                for (const key in this.control.errors) {
                    if (this.control.errors.hasOwnProperty(key)) {

                        if (this.validationService.validators.get(key)) {
                            const message = this.validationService.validators.validators[key].message;
                            let parameters;

                            if (typeof this.control.errors[key] === 'object') {
                                parameters = this.control.errors[key];
                            } else {
                                parameters = {value: this.control.errors[key]};
                            }

                            parameters['attribute'] = this.translateService.instant(this.element.label);

                            errors.push({
                                message: message,
                                parameters: parameters
                            });
                        }

                    }
                }
            }

            // Get all backend validation errors.
            const backendErrors = this.form.backendErrors[this.element.name];

            if (backendErrors) {
                for (const key in backendErrors) {
                    if (backendErrors.hasOwnProperty(key)) {
                        errors.push({
                            message: backendErrors[key],
                            parameters: {}
                        });
                    }
                }
            }
        }

        return errors;
    }

    /**
     * OnDestroy.
     */
    ngOnDestroy() {
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form/components/messages/messages.component.ts